import { useState, useContext, useEffect, useRef } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import MDInput from "components/MDInput";
import FormField from "components/FormField";
import { DataContext } from "context/dataContext";
import ErrorText from "components/ErrorText";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Autocomplete } from "@mui/material";
import { v4 as uuidv4 } from "uuid";

const AddQuestionForm = ({ showAsPopup }) => {
  const params = useParams();

  const { dataState, createQuestionApi } = useContext(DataContext);
  const navigate = useNavigate();

  const [value, setValue] = useState({
    question: "",
    description: "",
  });

  const [errors, setErrors] = useState({
    question: "",
    description: "",
  });

  const uuidvNumbers = () => {
    const uuid = uuidv4();
    const uuidFinal = uuid.replace(/\D/g, "").slice(0, 12);
    return Number(uuidFinal);
  };

  const validateForm = () => {
    const newErrors = {
      question: value.question ? "" : "Question is required",
      description: value.description ? "" : "Description is required",
    };

    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === "");
  };

  const handleQuestion = (e) => {
    setValue({ ...value, question: e.target.value });
  };

  const handleDescription = (e) => {
    setValue({ ...value, description: e.target.value });
  };

  const ResetValue = () => {
    setValue({ ...value, question: "" });
    setValue({ ...value, description: "" });
  };

  const handleSubmit = (e) => {
    console.log("value", value);
    e.preventDefault();

    if (validateForm()) {
      var question_id = uuidvNumbers();

      createQuestionApi({
        id: question_id,
        question: value.question,
        description: value.description,
        created_on: new Date(),
      }).then((res) => {
        if (res.success) {
          if (showAsPopup) {
            showAsPopup(false);
            console.log("Question added");
            //window.location.refresh(false);
          }
          ResetValue();
        } else {
          console.log("Something went wrong");
        }
      });
    }
  };

  return (
    <Card autoComplete="off" sx={{ height: "100%", ...(showAsPopup && { boxShadow: "none" }) }}>
      <MDBox p={3} pb={0}>
        <MDTypography variant="h5">Add a New Question</MDTypography>
      </MDBox>
      <MDBox p={3}>
        <MDBox component="form" pb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={showAsPopup ? 12 : 3}>
              <FormField
                type="text"
                value={value.question}
                onChange={handleQuestion}
                label="Question"
              />
              {errors.question && <ErrorText errorName={errors.question} />}
            </Grid>
            <Grid item xs={12} sm={showAsPopup ? 12 : 3}>
              <FormField
                type="text"
                multiline
                rows={3}
                label="Description"
                value={value.description}
                onChange={handleDescription}
              />
              {errors.description && <ErrorText errorName={errors.description} />}
            </Grid>
          </Grid>
        </MDBox>

        <MDBox mt={2} gap={2} width="100%" display="flex" justifyContent="flex-start">
          <MDButton variant="gradient" color="primary" onClick={handleSubmit}>
            Save Question
          </MDButton>
        </MDBox>
      </MDBox>
    </Card>
  );
};

export default AddQuestionForm;
